import React, { useCallback } from 'react';
import {
  Box,
  FormControl,
  FormLabel,
  ScaleFade,
  Slider,
  SliderFilledTrack,
  SliderThumb,
  SliderTrack,
  Textarea,
} from '@chakra-ui/react';

import { ScoreTypeEnum } from 'api-paths-cas';
import ScoreDetailsQuestionTranscript from './ScoreDetailsQuestionTranscript';

interface ScoreDetailsExplanationProps {
  isOpen: boolean;
  currentValue: number;
  setCurrentValue: (value: number) => void;
  currentExplanation: string;
  setCurrentExplanation: (value: string) => void;
  transcript?: string;
  type: ScoreTypeEnum;
  editDisclosureProps: React.HTMLAttributes<HTMLElement>;
}

export function ScoreDetailsExplanation(props: ScoreDetailsExplanationProps): React.ReactElement {
  const {
    type,
    isOpen,
    currentExplanation,
    transcript,
    currentValue,
    setCurrentValue,
    setCurrentExplanation,
    editDisclosureProps,
  } = props;

  const explanationChangeHandler: React.ChangeEventHandler<HTMLTextAreaElement> = useCallback(
    e => {
      setCurrentExplanation(e.target.value);
    },
    [setCurrentExplanation],
  );

  if (isOpen) {
    return (
      <ScaleFade in={isOpen}>
        <Box {...editDisclosureProps} mt="2">
          <FormControl mb="4">
            <FormLabel id={`${type}Label`}>Score</FormLabel>

            <Slider
              aria-labelledby={`${type}Label`}
              min={0}
              max={10}
              step={1}
              onChange={setCurrentValue}
              value={currentValue}
            >
              <SliderTrack>
                <SliderFilledTrack />
              </SliderTrack>

              <SliderThumb fontSize="sm" fontWeight="medium" boxSize="2rem" children={currentValue} />
            </Slider>
          </FormControl>

          <FormControl>
            <FormLabel>Explanation</FormLabel>

            <Textarea placeholder="Add explanation..." value={currentExplanation} onChange={explanationChangeHandler} />
          </FormControl>
        </Box>
      </ScaleFade>
    );
  }

  return (
    <Box mt="2">
      {currentExplanation}
      {transcript && <ScoreDetailsQuestionTranscript transcript={transcript} />}
    </Box>
  );
}
